import React, { useState } from 'react';
import Modal from '@eika-infrastruktur/ui-modal';

const InfoButton = ({ label, header, info }: { label?: string; header: string; info: string }) => {
    const [isVisible, setVisible] = useState(false);
    const toggleModal = () => setVisible(!isVisible);
    const closeModal = () => setVisible(false);
    return (
        <>
            <div className="info-link-wrapper">
                <button type="button" className="info-button" onClick={toggleModal}>
                    <i className="ikon-spoersmaalstegn-36" aria-hidden="true" />
                    <span className="info-link-label">{label}</span>
                </button>
            </div>
            {isVisible && (
                <Modal
                    headerIcon="ikon-spoersmaalstegn-36"
                    headerText={header}
                    onClickCallback={closeModal}
                    showModal={isVisible}
                >
                    <div>{info}</div>
                </Modal>
            )}
        </>
    );
};

export default InfoButton;
